<template>
    <div class="financeSection">
        <div class="financeSection-wrap">
            <div class="financeSection-header">
                <p class="h2">{{ dataBO.financeSect.financialTitle }}</p>
                <p>{{ dataBO.financeSect.financialContent }}</p>
            </div>

            <div class="financeSection-left">

                <p class="financeSection-title">1. Escolha a solução de Financiamento</p>
                <div class="financeSection-credType">
                    <div class="financeSection-cred">
                        <RadioButton name="financeType" :isChecked="isCredit" @change-credit="isCredit = !isCredit"/>
                        <div>
                            <p>Credit to Drive</p>
                            <p>O tradicional crédito automóvel.</p>
                        </div>
                    </div>
                    <div class="financeSection-hod">
                        <RadioButton name="financeType" :isChecked="!isCredit" @change-credit="isCredit = !isCredit"/>
                        <div>
                            <p>Open Drive</p>
                            <p>O crédito automóvel que lhe permite, no final do prazo, escolher se quer ficar, trocar ou devolver a sua viatura.</p>
                        </div>
                    </div>
                </div>

                <p class="financeSection-title">2. Ajuste as suas condições de Financiamento</p>
                <div class="financeSection-ranges">
                    <RangeFinance
                    :value.sync="userInitialValue"
                    label="Entrada Inicial"
                    curency="€"
                    name="financeType"
                    id="financeType"
                    :isChecked="true"
                    :step="parseInt(rangeData.minEntry)"
                    :min="parseInt(rangeData.minEntry)"
                    :max="parseInt(rangeData.maxEntry)" />
                    <RangeFinance
                    :value.sync="userNrPayments"
                    label="Prazo"
                    curency="meses"
                    name="financeType"
                    id="financeType"
                    :isChecked="true"
                    :min="parseInt(rangeData.minMonths)"
                    :max="parseInt(rangeData.maxMonths)"
                    :step="parseInt(rangeData.stepMonths)" />
                </div>

                <button class="btn-transparent--normal" :disabled="isDisabled" @click="updateValues">Atualizar valores</button>
            </div>

            <div :class="{ 'financeSection-right': true, center: showFinancesContent, flex: this.financeContent == null }">
                <span v-show="isMobile"
                :class="{ 'financeSection-rightTrack': true, open: isOpen }"
                @touchstart.passive="startDrag"
                @touchmove.passive="doDrag"></span>

                <template v-if="showFinancesContent">
                    <div v-if="(isOpen && isMobile) || !isMobile" class="financeSection-fixedHeader">
                        <p>Simulação Financeira:</p>
                        <svg v-show="isMobile && isOpen" @click="isOpen = !isOpen" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.29289 5.29289C5.68342 4.90237 6.31658 4.90237 6.70711 5.29289L12 10.5858L17.2929 5.29289C17.6834 4.90237 18.3166 4.90237 18.7071 5.29289C19.0976 5.68342 19.0976 6.31658 18.7071 6.70711L13.4142 12L18.7071 17.2929C19.0976 17.6834 19.0976 18.3166 18.7071 18.7071C18.3166 19.0976 17.6834 19.0976 17.2929 18.7071L12 13.4142L6.70711 18.7071C6.31658 19.0976 5.68342 19.0976 5.29289 18.7071C4.90237 18.3166 4.90237 17.6834 5.29289 17.2929L10.5858 12L5.29289 6.70711C4.90237 6.31658 4.90237 5.68342 5.29289 5.29289Z" fill="currentColor"/>
                        </svg>
                    </div>

                    <div class="financeSection-fixedOpen">
                        <FinanceReqBody :financeObj="financeContent" :isOpen="isOpen" :isMobile="isMobile" :boolIsOpen.sync="isOpen" />
                        <button class="btn-secondary-inverted" :disabled="!isDisabled" @click="openFormPropose">Pedir Proposta</button>
                        <a v-show="isOpen || !isMobile" :download="'FIN-' + resumeData.model" :href="getPDFLink" target="_blank">Descarregar FIN</a>
                    </div>
                </template>

                <template v-else-if="this.financeContent == null">
                    <div class="financeSection-noResult">
                        <p class="financeSection-noResult-title">Sem Resultados</p>
                        <p class="financeSection-noResult-subtitle">Ajuste as suas condições de simulação</p>
                        <p class="financeSection-noResult-subtitle">(entrada inicial e número de meses).</p>
                    </div>
                </template>

                <div v-else class="fncLoaderHolder" v-html="dataBO.svg.svgLoader"></div>
            </div>
        </div>
        <FormCfgData :content="financeContent" />
    </div>
</template>
<script>
    import axios from 'axios'
    import { mapGetters, mapMutations, mapState } from 'vuex'
    import RadioButton from '../../FormFields/RadioButton/RadioButton.vue'
    import RangeFinance from '../SimpleContent/RangeFinance.vue'
    import FinanceReqBody from '../SimpleContent/FinanceReqBody.vue'
    import { modalForms } from '../../../mixins/modalForms'
    import { mainFunctions } from '../../../mixins/mainFunctions'
    // import { modalPrice } from '../../../mixins/modalFunctions'
    import FormCfgData from '../Forms/FormCfgData.vue'

    export default {
        name: 'FinanceSection',
        components:{ RadioButton, RangeFinance, FinanceReqBody, FormCfgData},
        mixins: [modalForms, mainFunctions],
        props:{
            isMobile: {type: Boolean},
            price: {type: String, default: '0.00'},
            taeg: {type: [String, Number], default: '0.00'},
        },
        data(){return{
            isOpen: false,
            isDisabled: true,

            isCredit: true, // set credit type for sifa api and app

            userNrPayments: 0,
            userInitialValue: 0,
            financeContent: {}, // obj => response from sifa api (credit or hod)
            rangeData: {}, // component arr to set input["range"] (RangeFinance) values based on data from BO
            dragging: false,
            defaultY: 0,
        }},
        watch: {
            isCredit: function(val){
                this.setRangeLimits(val)
                this.updateValues()
            },
            userNrPayments: function(val, prev){
                this.isDisabled = (val == prev) ? true : false
            },
            userInitialValue: function(val,prev){
                this.isDisabled = (val == prev) ? true : false
            },
        },
        created(){
            if(this.resumeData.creditType == 'HOD') this.isCredit = false
        },
        mounted(){
            this.setRangeLimits(this.isCredit)
            this.fetchFinanceData_api()
        },
        computed:{
            ...mapState(['dataBO', 'resumeData', 'localDate']),
            ...mapGetters({
                getEngine: 'enginesData/getEngineById',
                getVersion: 'versionsData/getVersionById',
                modelPrice: 'resumeData/getFullPrice'
            }),
            getInicialEntry(){
                return this.userInitialValue;
            },
            getNrPayments(){
                return this.userNrPayments;
            },
            showFinancesContent(){
                let isEmpty = this.financeContent ? Object.keys(this.financeContent).length !== 0 : false
                return isEmpty
            },
            getPDFLink(){
                let pdfinBase64 = this.financeContent?.pdfinBase64
                if(pdfinBase64) return"data:application/pdf;base64," + escape(pdfinBase64)
                return false
            },
            handleModalFinSimulTitle(){
                let obj = this.resumeData;
                let fnc = this.financeContent
                let res = {
                    modelName: obj.model,
                    versionName: obj.configSelected.version.designation,
                };

                if(fnc.pvp) res.totalPriceFormated = fnc.pvp
                if(fnc.fee) res.rentFormated = fnc.fee

                return res
            },
            handleModalFinSimulData(){
                let obj = this.resumeData;
                let engineData = this.getEngine(obj.selectedEngine)
                let fnc = this.financeContent
                let version = this.getVersion(obj.versionID)
                let costs = version.legalizationGain + version.transportGain + version.ecoValue //legalização + transporte + ecovalor

                let res = {
                    modelName: obj.model,
                    versionName: obj.configSelected.version.designation,
                    co2: engineData.co2,
                    fuelConsumptionCombined: engineData.fuelCC,
                    nrPayments: fnc.nrPayments,
                    totalPriceFormated: parseInt(fnc.pvp),
                    initialValueFormated: parseFloat(fnc.initialValue).toFixed(2),
                    capitalToFinanceFormated: parseFloat(fnc.capitalToFinance).toFixed(2),
                    initialExpensesFormated: parseFloat(fnc.initialExpenses).toFixed(2),
                    rate: parseFloat(fnc.rate).toFixed(2),
                    taeg: parseFloat(fnc.taeg).toFixed(1),
                    mticFormated: parseFloat(fnc.mtic).toFixed(2),
                    rentFormated: parseFloat(fnc.fee).toFixed(2),
                    pvpWithoutFinanceFormated: parseFloat(version.pvpWithoutFinance).toFixed(2),
                    paiting: parseFloat(version.metalicColorPrice).toFixed(2),
                    costs: parseFloat(costs).toFixed(2),
                    date: this.buildDateString(fnc.dtEndOfCampaign),
                    postExpenses: parseFloat(fnc.postExpenses).toFixed(2),

                }

                if(!this.credit && fnc.residualValue) res.resiudalValue = fnc.residualValue.toFixed(2)

                return res
            }
        },
        methods:{
            ...mapMutations({
                updateCreditType: 'resumeData/UPDATE_CREDITTYPE',
            }),
            startDrag(e){
                this.defaultY = e.touches?.[0].clientY
                this.dragging = !this.dragging
            },
            doDrag(e) {
                let currentY = e.touches?.[0].clientY

                if (this.dragging && this.isMobile) {
                    if (currentY > this.defaultY) this.isOpen = false
                    if (currentY < this.defaultY) this.isOpen = true
                    this.dragging = !this.dragging
                }
            },
            ...mapMutations({
                updateResumeState: 'resumeData/UPDATE_STATE'
            }),
            showFinanceLst(){
                this.isOpen = !this.isOpen
            },
            updateValues(){
                // handle btn actions
                this.fetchFinanceData_api()
                this.isOpen = true;
                this.isDisabled = true;
                this.financeContent = {}

            },
            fetchFinanceData_api(){
                // handle Api data/params
                let __isCredit = this.isCredit;
                let resume = this.resumeData
                let _dataBO = this.dataBO.credit
                let version = this.getVersion(resume.versionID)

                let minInitialValue = this.rangeData.minEntry
                let initialValue = this.userInitialValue
                let nrPayments = this.userNrPayments
                let minRate = __isCredit ? _dataBO.cred_minRate : _dataBO.hod_rate
                let rate = __isCredit ? _dataBO.cred_maxRate : _dataBO.hod_rate

                // let price = parseInt(this.modelPrice)
                let price = __isCredit ? parseInt(this.modelPrice) : version.pvpWithoutFinance
                let isCred = __isCredit ? 'S' : 'N'

                /**
                 * if is HOD ? get residualValue
                 */
                let residualValuePercent = 0
                const arrResidualValues = version.arrResidualValues;
                const arrResidualValuesLength = arrResidualValues.length;

                for (let i = 0; i < arrResidualValuesLength; i++) {
                    const el = arrResidualValues[i];
                    if(el.monthPeriod == this.userNrPayments && el.valueType == 'P'){
                        residualValuePercent = el.valueVal;
                        break;
                    }
                }

                const residualValueDivisor = residualValuePercent > 1 ? 100 : 1
                let residualValue = !__isCredit ? price * (residualValuePercent / residualValueDivisor) : 0

                let finReqData = `${resume.versionID}/${Math.round(version.pvpWithoutFinance)}/${Math.round(price)}/${minInitialValue}/${initialValue}/${nrPayments}/${minRate}/${rate}/${residualValue}/${isCred}`
                axios.get(process.env.VUE_APP_HYU + process.env.VUE_APP_API_UPDATE_FINANCES + finReqData)
                .then(res => {
                    // let data = res.data.lstFinancialInfo[0]
                    let data = res.data.financialInfo
                    this.financeContent = data

                    this.updateCreditType(this.isCredit)
                    this.updateResumeState({
                        rent: data.fee,
                        taeg: data.taeg,
                        maxMounths: data.nrPayments,
                        incialEntry: data.initialValue,
                        financing: data.capitalToFinance,
                        pdfinBase64: data.pdfinBase64,
                        hasFinances: data,
                        residualValue: data.residualValue,
                    })

                    this.userInitialValue = data.initialValue
                    this.userNrPayments = data.nrPayments

                    setTimeout(() => {
                        this.isDisabled = true
                    }, 123);
                })
                .catch(err => console.log(err))
            },
            setRangeLimits(isCred){
                let res = {}
                let obj = this.dataBO.credit;
                let version = this.getVersion(this.resumeData.versionID)

                res.minMonths = isCred ? obj.credMinMonths : obj.hodMinMonths
                res.maxMonths = isCred ? obj.credMaxMonths : obj.hodMaxMonths
                res.stepMonths = isCred ? obj.credStep : obj.hodStep
                res.minEntry  = isCred ? obj.credMinEntry : obj.hodMinEntry
                const maxEntry  = isCred ? version.price * (obj.credMaxEntry / 100) : version.price * (obj.hodMaxEntry / 100)
                res.maxEntry  = Math.floor (maxEntry / 500) * 500

                this.userInitialValue = this.resumeData.incialEntry
                this.userNrPayments = res.maxMonths
                this.rangeData = res
            },
        },
    }
</script>
<style lang="scss">
    @import './FinanceSection.scss';
</style>
